"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_i18next_1 = require("react-i18next");
var react_modal_1 = __importDefault(require("react-modal"));
var FormAmountView_1 = __importDefault(require("./component/FormAmountView"));
var FormConditionView_1 = __importDefault(require("./component/FormConditionView"));
var FormItemView_1 = __importDefault(require("./component/FormItemView"));
var FormPaymentView_1 = __importDefault(require("./component/FormPaymentView"));
var FormSubmitView_1 = __importDefault(require("./component/FormSubmitView"));
var FormValuesView_1 = __importDefault(require("./component/FormValuesView"));
var OrderServiceContext_1 = require("./OrderServiceContext");
var customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        minWidth: '50%'
    },
};
var OrderServiceView = function () {
    var _a;
    var _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n;
    var _c = (0, react_1.useState)(), _payment = _c[0], _setPayment = _c[1];
    var _d = (0, react_1.useState)(), _currency = _d[0], _setCurrency = _d[1];
    var cc = require('currency-codes');
    var dc = (_a = document.getElementById("react-service-form")) === null || _a === void 0 ? void 0 : _a.getAttribute('data-currency-default');
    var _e = (0, react_1.useState)(typeof dc === 'string'
        ? parseInt(dc)
        : parseInt(cc.code('RUB').number)), _defaultCurrency = _e[0], _setDefaultCurrency = _e[1];
    var _f = (0, react_1.useState)(true), _isConditionAccept = _f[0], _setIsConditionAccept = _f[1];
    var _g = (0, react_1.useState)(), _exchanger = _g[0], _setExchanger = _g[1];
    var _h = (0, react_1.useState)(), _orderService = _h[0], _setOrderService = _h[1];
    var methods = (0, react_hook_form_1.useForm)();
    var _j = (0, react_1.useState)(false), modalIsOpen = _j[0], setIsOpen = _j[1];
    var _k = (0, react_1.useState)(false), submitForm = _k[0], setSubmitForm = _k[1];
    var values = (0, react_1.useMemo)(function () { return ({
        payment: _payment,
        currency: _currency,
        isConditionAccept: _isConditionAccept,
        orderService: _orderService,
        defaultCurrency: _defaultCurrency,
        exchanger: _exchanger,
        setPayment: _setPayment,
        setCurrency: _setCurrency,
        setIsConditionAccept: _setIsConditionAccept,
        setOrderService: _setOrderService,
        setExchanger: _setExchanger
    }); }, [
        _payment, _currency, _isConditionAccept, _orderService, _defaultCurrency, _exchanger,
        _setPayment, _setCurrency, _setIsConditionAccept, _setOrderService, _setExchanger
    ]);
    (0, react_1.useEffect)(function () {
        var formNode = document.getElementById("react-service-form");
        var hash = formNode === null || formNode === void 0 ? void 0 : formNode.getAttribute('data-hash');
        if (hash !== null && hash !== undefined) {
            axios_1.default.get("/app/order/service/".concat(hash))
                .then(function (response) {
                if (response.status == 200) {
                    console.log(response.data);
                    _setOrderService(response.data);
                }
            });
        }
        if (formNode) {
            var _wmu = formNode.getAttribute('data-wmu');
            var _wmz = formNode.getAttribute('data-wmz');
            var _wme = formNode.getAttribute('data-wme');
            (_wme && _wmu && _wmz) && _setExchanger({
                wme: parseFloat(_wme),
                wmu: parseFloat(_wmu),
                wmz: parseFloat(_wmz),
                usdt: parseFloat(_wmz)
            });
        }
        react_modal_1.default.setAppElement('#react-service-form');
    }, []);
    var onSubmit = function (data) {
        setSubmitForm(true);
        axios_1.default.post("/app/order/service/create", data)
            .then(function (response) {
            if (response.status == 200) {
                if (response.data.redirect)
                    window.location.href = response.data.redirect;
            }
        }).catch(function (error) {
            console.log("eror", error);
        });
    };
    return (react_1.default.createElement(OrderServiceContext_1.OrderServiceContext.Provider, __assign({}, methods, { value: values }),
        react_1.default.createElement(react_hook_form_1.FormProvider, __assign({}, methods),
            react_1.default.createElement("form", { onSubmit: methods.handleSubmit(onSubmit), className: "order-service-form" },
                react_1.default.createElement(FormValuesView_1.default, null),
                react_1.default.createElement(react_modal_1.default, { isOpen: modalIsOpen, onRequestClose: function () { setIsOpen(false); }, style: customStyles },
                    react_1.default.createElement("div", { className: "purchase-wrap-content", style: { width: '100%' } },
                        react_1.default.createElement("div", { className: "__wrap-caption" },
                            react_1.default.createElement("span", { className: "__caption" }, "Request"),
                            react_1.default.createElement("img", { onClick: function () { setIsOpen(false); }, className: "close-modal", src: "/images/app/close.svg" })),
                        react_1.default.createElement("div", { className: "__wrap-text" }, "go to payment"))),
                react_1.default.createElement("div", { className: "__wrap-field" },
                    react_1.default.createElement("div", { className: "__wrap-field-left" },
                        react_1.default.createElement("div", { className: "__wrap-field-left-wrap" },
                            react_1.default.createElement(FormItemView_1.default, { caption: t("service.view.order.game.name"), value: _orderService === null || _orderService === void 0 ? void 0 : _orderService.game_name }),
                            react_1.default.createElement(FormItemView_1.default, { caption: t("service.view.order.service.name"), value: _orderService === null || _orderService === void 0 ? void 0 : _orderService.service_name }),
                            react_1.default.createElement(FormPaymentView_1.default, null))),
                    react_1.default.createElement("div", { className: "__wrap-field-right" },
                        react_1.default.createElement("div", { className: "__caption" }, t("service.view.order.server.desription")),
                        react_1.default.createElement("div", { className: "__description" }, _orderService === null || _orderService === void 0 ? void 0 : _orderService.service_description),
                        react_1.default.createElement("div", { className: "__wrap-condition" },
                            react_1.default.createElement(FormConditionView_1.default, null)))),
                react_1.default.createElement("div", { className: "__wrap-order-submit" },
                    react_1.default.createElement("div", { className: "__payment-value" },
                        react_1.default.createElement(FormAmountView_1.default, null)),
                    react_1.default.createElement("div", { className: "__submit-buttom" },
                        react_1.default.createElement(FormSubmitView_1.default, { onClick: submitForm })))))));
};
exports.default = OrderServiceView;
